import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import PayMethodList from '../../../../checkout/fragments/payment-methods'
import BottomToTop from '../../../../../../../components/transitions/bottom-to-top'
import { BlackMask } from '../../../../../../../components/mask'
import { FormattedMessage } from 'react-intl'
import { Iconfont } from '../../../../../../../components/icon/iconfont'
import PaypalButton from '../../../../../components/paypal-button'
import ApplePayButton from '../../../../../components/applepay-button'
import GooglePayButton from '../../../../../components/google-button'

import SafechargeApplePay from '../../../../../components/safecharge/applepay'
import SafechargeGooglePay from '../../../../../components/safecharge/google'
import AfterPayCashAppPay from '../../../../../components/cash-app-pay'

import { BigButton } from '../../../../../../../components/button'
import { unitPrice } from '../../../../../../../../utils/product'
import { SensorsTrack } from '../../../../../../../utils/sensor'



export const PaymentMethods = props => {
    useStyles(classes)
    const { payMethods, orderTotal, onClose, selectPayMethodHandle, selectedPayMethod, inputOrder, selectedCard, onError, pay, paying, country, isFastPayment, check } = props


    const usePaypalButton = selectedPayMethod?.type === '1'
    const useGoogleButton = selectedPayMethod?.type === '41'
    const useAppleButton = selectedPayMethod?.type === '32'

    const useSafechargeApplePay = selectedPayMethod?.type === '42'
    const useSafechargeGooglePay = selectedPayMethod?.type === '43'
    const useCashAppPay = selectedPayMethod?.type === '44'

    const clickHandle = () => {
        SensorsTrack('CartAction', {
            action: `ClickPayNow_${selectedPayMethod?.id}`
        })
    }

    return <div className={classes.PaymentMethods}>
        <div className={classes.Hd}>
            <span className={classes.Title}>
                <FormattedMessage id="payment_method" defaultMessage="Payment Method" />
            </span>
            <Iconfont className={classes.Close} onClick={onClose}>&#xe7c9;</Iconfont>
        </div>
        <div className={classes.Bd}>
            <PayMethodList
                orderTotal={orderTotal}
                selectPayMethodHandle={selectPayMethodHandle}
                selectedPayMethod={selectedPayMethod?.id}
                payMethodList={payMethods}
                ignoreViewMore
                inputOrder={inputOrder}
                selectedCard={selectedCard}
                onError={onError}
                shoudBilling
                check={check}
            />
        </div>
        <div className={classes.Fd}>
            {
                useAppleButton && <ApplePayButton check={check} isFastPayment={isFastPayment} clickHandle={clickHandle} onError={onError} payMethod={selectedPayMethod?.id} orderTotal={orderTotal} country={country} shoudBilling />
            }
            {
                usePaypalButton && <PaypalButton check={check} isFastPayment={isFastPayment} clickHandle={clickHandle} domId={'cart-method-paypal'} onError={onError} shoudBilling />
            }


            {
                useGoogleButton && <GooglePayButton check={check} isFastPayment={isFastPayment} clickHandle={clickHandle} onError={onError} payMethod={selectedPayMethod?.id} orderTotal={orderTotal} country={country} shoudBilling/>
            }


            {
                useSafechargeApplePay && <SafechargeApplePay check={check} clickHandle={clickHandle} isFastPayment={isFastPayment} onError={onError} payMethod={selectedPayMethod?.id} orderTotal={orderTotal} country={country} shoudBilling />
            }

            {
                useSafechargeGooglePay && <SafechargeGooglePay check={check} clickHandle={clickHandle} isFastPayment={isFastPayment} onError={onError} payMethod={selectedPayMethod?.id} orderTotal={orderTotal} country={country} shoudBilling />
            }

            {
                useCashAppPay && <AfterPayCashAppPay check={check} clickHandle={clickHandle} isFastPayment={isFastPayment} onError={onError} payMethod={selectedPayMethod?.id} orderTotal={orderTotal} country={country} shoudBilling
                    content={
                        <>
                            <FormattedMessage id="pay_now" defaultMessage="Pay Now" />{' '}
                            {unitPrice(orderTotal)}
                        </>
                    }
                    className={classes.CheckoutButton} />
            }

            {
                !useAppleButton && !usePaypalButton && !useGoogleButton && !useSafechargeApplePay && !useSafechargeGooglePay && !useCashAppPay && <BigButton isFastPayment={isFastPayment} loading={paying} onClick={pay}>
                    <FormattedMessage id="pay_now" defaultMessage="Pay Now" />{' '}
                    {unitPrice(orderTotal)}
                </BigButton>
            }
        </div>
    </div>
}


export default props => {
    useStyles(classes)
    return <React.Fragment>
        <BottomToTop in={props.show} className={classes.PaymentMethodsContainer}>
            <div>
                <PaymentMethods {...props} />
            </div>
        </BottomToTop>
        {props.show && <BlackMask onClick={props.onClose} />}
    </React.Fragment>
}